<template>
    <div id="app">
        <div id="top">
            <Menu v-show="!store.mobileMenu"></Menu>
            <MobileMenu v-if="$mq == 'sm' && store.mobileMenu"></MobileMenu>
            <Player v-show="!store.mobileMenu && store.live"></Player>
        </div>
        <keep-alive>
            <router-view
                :key="$route.fullPath"
                v-show="!store.mobileMenu || $mq != 'sm'"
                id="content"
                :class="{
                    archiveContent: $route.name == 'archive',
                }"
                v-keep-scroll-position
            ></router-view>
        </keep-alive>
        <!--
        <Support v-if="$mq != 'sm'"></Support>
        -->
        <PrivatePlayer v-show="store.privatePlayerVisible"></PrivatePlayer>

        <SubscriptionPopup v-if="store.showSubWarnPopup"></SubscriptionPopup>
        <SubscriptionExpiredPopup
            v-if="store.showSubExpiredPopup"
        ></SubscriptionExpiredPopup>
        <SwitchPopup v-if="store.showSwitchPopup"></SwitchPopup>
        <AddPopup v-if="store.showAddPopup"></AddPopup>
        <SupportPopup v-if="store.showSupportPopup"></SupportPopup>
        <LikePopup v-if="store.showLikePopup"></LikePopup>
    </div>
</template>

<script>
import Menu from "./newComponents/Menu.vue";
import MobileMenu from "./newComponents/MobileMenu.vue";
import Player from "./newComponents/Player.vue";
import PrivatePlayer from "./newComponents/PrivatePlayer.vue";
import Support from "./newComponents/Support.vue";
import SubscriptionPopup from "./newComponents/SubscriptionPopup.vue";
import SubscriptionExpiredPopup from "./newComponents/SubscriptionExpiredPopup.vue";
import SwitchPopup from "./newComponents/SwitchPopup.vue";
import AddPopup from "./newComponents/AddPopup.vue";
import SupportPopup from "./newComponents/SupportPopup.vue";
import LikePopup from "./newComponents/LikePopup.vue";
import { store } from "./store";
import axios from "axios";
import { DateTime } from "luxon";
import _ from "lodash";

export default {
    name: "app",
    components: {
        Menu,
        MobileMenu,
        Player,
        Support,
        PrivatePlayer,
        SubscriptionPopup,
        SubscriptionExpiredPopup,
        SwitchPopup,
        AddPopup,
        SupportPopup,
        LikePopup,
    },
    data() {
        return {
            store: store,
        };
    },
    watch: {
        // whenever question changes, this function will run
        "store.cart": {
            handler(newCart) {
                localStorage.cart = JSON.stringify(newCart);
            },
            deep: true,
        },
    },
    methods: {
        pollArchive: function () {
            axios.get("/api/get-tasks").then((response) => {
                //this.playlist = response.data.jobs;
                this.store.playlist = response.data.playlist;
                //this.store.playingItem = this.store.playlist.items.find(
                //item => item.playing == true
                //);
                this.store.streams = response.data.streams;
                //this.listState.listLength = this.playlist.length;
                //this.liveTrack = {id: 0};
                //if (this.playlist.length > 0){
                //if (this.playlist[0].pk != this.currentTrack.pk){
                //this.currentTrack = this.playlist[0];
                //}
                //} else {
                //this.currentTrack.pk = 0;
                //}
                //if (this.playlist.length <= 11){
                //this.mayAddToPlaylist = true;
                //} else {
                //this.mayAddToPlaylist = false;
                //}
            });
            //.catch(error => console.log(error))
        },

        pollLive: function () {
            //axios
            //.get('/api/get-live-track')
            //.then(response => {
            //if (this.liveTrack.id == 0 || this.liveTrack.id != response.data.id){
            //this.liveTrack = response.data;
            //}
            //this.store.liveTrack = response.data;
            //})
            axios.get("/api/get-live-items").then((response) => {
                if (response.data) {
                    this.store.liveList = response.data.schedule_list;
                    // this.store.liveTrack = response.data.live_track;
                    // this.store.liveFuture = response.data.future_list;
                    let scheduleList = response.data.schedule_list;
                    scheduleList.forEach((item) => {
                        let aware = DateTime.fromISO(item.start_time, {
                            zone: item.timezone,
                        });
                        // let local = aware.setZone("local");
                        item["aware"] = aware;
                        item["utc"] = aware.toUTC();
                    });

                    let orderedList = _.sortBy(scheduleList, [
                        function (item) {
                            return item.utc.valueOf();
                        },
                    ]);

                    let playingList = orderedList.filter((item) => {
                        return item.utc.valueOf() < DateTime.utc().valueOf();
                    });
                    this.store.groupedLiveList = _.groupBy(
                        orderedList,
                        function (item) {
                            return item.aware.setZone("local").toISODate();
                        }
                    );

                    if (playingList.length == 0) {
                        this.store.liveTrack = this.store.liveList[0];
                    } else {
                        this.store.liveTrack =
                            playingList[playingList.length - 1];
                    }
                    // this.store.liveTrack = this.store.liveList[0];
                    //this.store.liveTrack = playingList.at(-1);
                    // this.store.groupedLiveList = _.orderBy(groupedList
                }
            });
        },

        pollLiveState: function () {
            axios.get("/api/get-live-status").then((response) => {
                //var switched = this.live != response.data.on;
                //this.live = response.data.on;
                this.store.live = response.data.live_radio.on;
                //this.livePlace = response.data.place;
                // this.store.livePlace = response.data.live_radio.place;
                this.store.showSchedule =
                    response.data.live_radio.show_schedule;

                //this.liveTimezone = response.data.timezone;
                // this.store.liveTimezone = response.data.live_radio.timezone;
                this.store.jingles = response.data.jingles;
                this.store.present50 = response.data.present50;
                this.store.present100 = response.data.present100;
                this.store.present1000 = response.data.present1000;
                this.store.present50Text = response.data.present50Text;
                this.store.present100Text = response.data.present100Text;
                this.store.present1000Text = response.data.present1000Text;
                this.store.presentSup = response.data.presentSup;
                this.store.presentDon = response.data.presentDon;
                // if (response.data.live_radio.on == false) {
                this.pollArchive();
                //if (this.allowPopUp == true && switched){
                //alert('We are now switching to archived radio.');
                //}
                //this.allowPopUp = true;
                //} else {
                //this.pollLive();
                //this.currentTrack.pk = 0;
                //this.listState.listLength = 2;
                //if (this.allowPopUp == true && switched){
                //alert('We are now switching to live radio.');
                //}
                //this.allowPopUp = true;
                // }
                this.pollLive();
            });
        },
    },
    created() {
        this.pollLiveState();
        if (localStorage.getItem("authenticated") == "success") {
            this.store.lastPayed = localStorage.getItem("lastPayed");
            this.store.giftEligible = localStorage.getItem("giftEligible");
            this.store.userID = localStorage.getItem("userID");
            this.store.accountActive = localStorage.getItem("accountActive");
            this.store.confirmed =
                localStorage.getItem("confirmed") == "true" ? true : false;
            if (localStorage.getItem("likes")) {
                this.store.likes = JSON.parse(localStorage.getItem("likes"));
            } else {
                this.store.likes = [];
            }
            if (this.store.accountActive) {
                //let now = DateTime.utc()
                //let payed = DateTime.fromISO(this.store.lastPayed)
                //let interval = Interval.fromDateTimes(payed, now)
                //if (interval.length('days') > this.store.expireTime){
                //this.store.authenticated = true;
                //this.store.showSubExpiredPopup = true
                //} else if (interval.length('days') > this.store.expireWarning){
                //this.store.authenticated = true;
                //this.store.showSubWarnPopup = true
                //this.store.valid = true;
                //} else {
                //this.store.authenticated = true;
                //this.store.valid = true;
                //}
                this.store.authenticated = true;
                this.store.valid = true;
            } else {
                this.store.authenticated = true;
            }
        } else {
            this.store.authenticated = false;
        }
        //if (sessionStorage.getItem('jinglePlayed')){
        //this.store.allowJingle = false;
        //}
    },
    mounted: function () {
        this.pollLiveState();
        let myself = this;
        setTimeout(function () {
            myself.store.playerCanPopup = true;
        }, 5000);
        setInterval(() => {
            myself.pollLiveState();
        }, 10000);
        if (localStorage.cart) {
            this.store.cart = JSON.parse(localStorage.cart);
        }
        // }, 3000);
    },
};
</script>

<style>
@font-face {
    font-family: "Montez Large";
    src: url("/static/MontezGrotesque2-05-WebLarge.woff");
}

@font-face {
    font-family: "Montez Small";
    src: url("/static/MontezGrotesque2-05-WebSmall.woff");
}

html {
    /*font-size: 3.2vw;*/
    height: 100%;
    font-size: 12px;
    font-family: "Montez Small";
}

@media only screen and (min-width: 529px) {
    html {
        /*font-size: 2.27vw;*/
    }
}

@media only screen and (min-width: 738px) {
    html {
        /*font-size: 1.63vw;*/
    }
}

@media only screen and (min-width: 1101px) {
    html {
        /*font-size: 12px;*/
    }
}

@media only screen and (min-width: 1440px) {
    html {
    }
}

* {
    /* background-color: rgba(100, 150, 250, 0.1); */
    /* outline: 1px solid red; */
}

body {
    margin: 0;
    height: 100%;
}

#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: "Montez Large";
    font-size: 1.333rem;
    /* height: calc(100vh + 1px); */
    /* height: calc(100dvh + 1px); */
    height: 100vh;
    height: 100dvh;
    line-height: 1.667rem;
    /*line-height: 1.167rem;*/
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

a {
    text-decoration: none;
    color: black;
}

.elementContainer {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(350px, 100%), 1fr));
    grid-gap: calc(2rem - 6px) 1rem;
    margin: 1rem 1rem calc(2rem - 6px);
}

/* .elementContainer{ */
/*     display: flex; */
/*     flex-direction: row; */
/*     flex-wrap: wrap; */
/* } */
/* @media only screen and (min-width: 738px){ */
/* .elementContainer{ */
/*     display: grid; */
/*     grid-template-columns: 50% 50%; */
/*     grid-gap: 2rem 1rem; */
/*     margin: 1rem; */
/*     width: calc(100% - 3rem); */
/* } */
/* } */
/* @media only screen and (min-width: 1101px){ */
/* .elementContainer{ */
/*     grid-template-columns: 33.3% 33.3% 33.3%; */
/*     grid-template-columns: repeat(3, 33.3%); */
/*     width: calc(100% - 4rem); */
/* } */
/* } */
/* @media only screen and (min-width: 1440px){ */
/* .elementContainer{ */
/*     grid-template-columns: repeat(4, 25%); */
/*     width: calc(100% - 5rem); */
/* } */
/* } */
/* @media only screen and (min-width: 1900px){ */
/* .elementContainer{ */
/*     grid-template-columns: repeat(5, 20%); */
/*     width: calc(100% - 6rem); */
/* } */
/* } */
.large {
    font-family: "Montez Large";
    font-size: 1.333rem;
    /*line-height: 1.583rem;*/
}

#top {
    /* position: fixed; */
    /* top: 0; */
    /* width: 100%; */
    z-index: 5;
}

#content {
    overflow: scroll;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    margin-top: -1px;

    /* padding-top: 2.9rem; */
    /* padding-bottom: 1rem; */
    /* min-height: calc(100vh - 13.1rem); */
    /* transition: min-height 0.5s; */
    /* margin-top: -1px; */
}

/* #routerContent { */
/*     flex-grow: 1; */
/*     margin-top: -1px; */
/* } */
.miscContent {
    padding: 0.7rem 1rem 0.8rem;
    box-sizing: border-box;
    width: min(750px, 100%);
}

/* #content.home { */
/*     padding-bottom: 0rem; */
/* } */
/* @-moz-document url-prefix() { */
/*     #content { */
/*         /* min-height: calc(100vh - 13.1rem); */
/*         min-height: calc(100vh - 7.2rem); */
/*     } */
/*     #content.bannerVisible { */
/*         min-height: calc(100vh - 13.2rem); */
/*     } */
/* } */
/* #content.liveContent { */
/*     padding-top: 6.7rem; */
/* } */
/* #content.liveContent.bannerVisible { */
/*     min-height: calc(100vh - 27.1rem); */
/* } */
/* @-moz-document url-prefix() { */
/*     #content.liveContent { */
/*         padding-top: 6.3rem; */
/*     } */
/* } */
/* #content.privatePlayerContent.extendedPrivatePlayer { */
/* padding-bottom: 8.1rem; */
/* } */

/* @media only screen and (min-width: 738px) { */
/*     #content.liveContent.bannerVisible { */
/*         min-height: calc(100vh - 16.2rem); */
/*     } */
/*     #content.privatePlayerContent { */
/*         min-height: calc(100vh - 16.7rem); */
/*         padding-bottom: 7.5rem; */
/*     } */
/*     #content.privatePlayerContent.home { */
/*         padding-bottom: 6rem; */
/*     } */
/*     #content.privatePlayerContent.home.extendedPrivatePlayer { */
/*         padding-bottom: 6.6rem; */
/*     } */
/*     #content { */
/*         padding-top: 3.2rem; */
/*     } */
/*     #content.liveContent { */
/*         padding-top: 6.4rem; */
/*         min-height: calc(100vh - 10.4rem); */
/*     } */
/*     @-moz-document url-prefix() { */
/*         #content { */
/*             padding-top: 3.2rem; */
/*         } */
/*         #content.liveContent { */
/*             padding-top: 6.4rem; */
/*             min-height: calc(100vh - 10.4rem); */
/*         } */
/*     } */
/*     #content.privatePlayerContent { */
/*         min-height: calc(100vh - 13.4rem); */
/*         padding-bottom: 1rem; */
/*     } */
/*     #content.privatePlayerContent.liveContent { */
/*         min-height: calc(100vh - 16.6rem); */
/*     } */
/*     #content.privatePlayerContent.bannerVisible { */
/*         min-height: calc(100vh - 20.4rem); */
/*     } */
/*     #content.privatePlayerContent.liveContent.bannerVisible { */
/*         min-height: calc(100vh - 22.4rem); */
/*     } */
/*     #content.privatePlayerContent.home { */
/*         padding-bottom: 0rem; */
/*     } */
/*     #content.privatePlayerContent.home.extendedPrivatePlayer { */
/*         padding-bottom: 0rem; */
/*     } */
/* } */
/* .smallContent { */
/* } */
/* .miscContent { */
/*     margin: 1.1rem 1rem 0rem; */
/*     width: calc(100% - 2rem); */
/* } */
/* @media only screen and (min-width: 738px) { */
/*     .miscContent { */
/*         width: 50%; */
/*     } */
/* } */
/* @media only screen and (min-width: 1101px) { */
/*     .miscContent { */
/*         width: 33%; */
/*     } */
/* } */
/* @media only screen and (min-width: 1440px) { */
/*     .miscContent { */
/*         width: calc(25% - 2rem); */
/*     } */
/* } */
/* @media only screen and (min-width: 1900px) { */
/*     .miscContent { */
/*         width: calc(20% - 2rem); */
/*     } */
/* } */

.smallContent {
    flex-grow: 1;
}

input,
textarea {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid black;
    border-radius: 0;
    padding: 0.65rem 1rem 0.85rem;
    margin: 1rem 0 0;
    background-color: white;
    font-family: "Montez Large";
    font-size: 1.333rem;
}

input:focus,
textarea:focus {
    outline: none;
}

input:first-child {
    margin-top: 0;
}

input[type="submit"] {
    cursor: pointer;
    color: black;
}

input[type="submit"]:hover {
    background-color: black;
    color: white;
}

@supports (-webkit-appearance: none) or (-moz-appearance: none) {
    input[type="text"],
    input[type="password"],
    input[type="submit"] {
        -webkit-appearance: none;
        -moz-appearance: none;
    }
}
</style>
